import { Modal } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ArrowForward } from "../../../../../../../../assets/icons/ArrowForward";
import { Button } from "../../../../../../../../components/Button";
import { getTooltipTitleFor } from "../../../../../../../../utils/measurementsUtils";
import {
  ButtonContainer,
  CancelButton,
  confirmModalCss,
  ContentContainer,
  ModalSubtitle,
} from "../../CustomOptionsBar.styles";
import {
  ChangeContainer,
  Content,
  NoteContainer,
  NoteSubtitle,
  NoteTitle,
  PropTitle,
} from "./ConfirmBaselineChangeModal.styles";

type ConfirmBaselineChangeModalProps = {
  unit?: string;
  oldBaseline: string;
  newBaseline: string;
  measurementType: string;
  isISHLTBaseline: boolean;
  onClose(confirm: boolean, iISHLTBaseline: boolean, unit?: string): void;
};

export function ConfirmBaselineChangeModal({
  unit,
  oldBaseline,
  measurementType,
  newBaseline,
  isISHLTBaseline,
  onClose,
}: ConfirmBaselineChangeModalProps) {
  const { t } = useTranslation();

  const [isLoading, setIsLoading] = useState(false);
  const [unitToSave] = useState(unit);

  const handleConfirmUpdate = () => {
    setIsLoading(true);

    onClose(true, isISHLTBaseline, unitToSave);
  };

  const handleCancel = () => {
    onClose(false, isISHLTBaseline, undefined);
  };

  return (
    <Modal
      title={t("patientPage_measurementModal_baselineModal_confirmChanges")}
      open
      zIndex={3001}
      footer={null}
      width={600}
      height="400px !important"
      onCancel={handleCancel}
      className={confirmModalCss()}
      centered
      destroyOnClose
    >
      <ContentContainer>
        <ModalSubtitle>
          {t("patientPage_measurementModal_baselineModal_confirmBody", {
            baseline: !isISHLTBaseline
              ? t(
                  "patientPage_measurementModal_baselineModal_measurementName",
                  {
                    measurement: getTooltipTitleFor(measurementType),
                  }
                )
              : t("patientPage_measurementModal_baselineModal_ishltName"),
          })}
        </ModalSubtitle>

        <ChangeContainer>
          <PropTitle>
            {t("patientPage_measurementModal_baselineModal_baseline")}
          </PropTitle>
          <Content>
            <p>{oldBaseline}</p>
            <div
              style={{
                margin: "0 8px",
                alignItems: "center",
                display: "flex",
              }}
            >
              <ArrowForward />
            </div>
            <p>{newBaseline}</p>
          </Content>
        </ChangeContainer>

        <NoteContainer>
          <NoteTitle>
            {t("patientPage_measurementModal_baselineModal_noteTitle")}
          </NoteTitle>
          <NoteSubtitle>
            {t("patientPage_measurementModal_baselineModal_noteBody")}
            <b style={{ fontWeight: 500 }}>
              {t("patientPage_measurementModal_baselineModal_noteEmphasis")}
            </b>
          </NoteSubtitle>
        </NoteContainer>

        <ButtonContainer>
          <Button
            label={t("patientPage_measurementModal_baselineModal_confirm")}
            type="button"
            onClick={handleConfirmUpdate}
            isLoading={isLoading}
          />
          <CancelButton isModal onClick={handleCancel}>
            {t("common_cancel")}
          </CancelButton>
        </ButtonContainer>
      </ContentContainer>
    </Modal>
  );
}
